/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const HabitFood = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
};
export function HabitFoodFromJSON(json) {
    return HabitFoodFromJSONTyped(json, false);
}
export function HabitFoodFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function HabitFoodToJSON(value) {
    return value;
}
